import { ThemeService } from './ThemeService';
import { find } from 'lodash';

export class MobileThemeService extends ThemeService {

  static VIEWPORT_FIT_COVER_METADATA = 'viewport-fit=cover';

  get viewportElement() {
    const metas = window.document.getElementsByTagName('META');
    const viewport = find(metas, meta => meta.getAttribute('name') === 'viewport');
    return viewport;
  }

  injectTheme(theme = this.THEMES.THEME_TO_BUILD_A_PROFILE_PROFILES) {
    const injected = super.injectTheme(theme);
    this.addViewportFitMetadata();
    return injected;
  }

  addViewportFitMetadata() {
    const viewportElement = this.viewportElement;
    if (!viewportElement) {
      return;
    }

    const viewportContent = viewportElement.getAttribute('content') || '';
    const updatedContent = viewportContent
      ? `${viewportContent}, ${MobileThemeService.VIEWPORT_FIT_COVER_METADATA}`
      : MobileThemeService.VIEWPORT_FIT_COVER_METADATA;
    viewportElement.setAttribute('content', updatedContent);
  }

}
export const mobileThemeService = new MobileThemeService();
